import {Component, ViewChild, TemplateRef}  from "@angular/core";
import {BaseComponent, ActionDialog} from "../../base-module/base-component/base.component";
import { Router } from "@angular/router";
import {FormControl} from "@angular/forms";
import { AuthService } from "app/base-module/base-service/auth.service";
import {SelectionType} from "@swimlane/ngx-datatable";
import { FiltrarBoletaComponent } from "app/movimentacao/filtrar-boleta/filtrar-boleta.component";
import { BoletaPrevidenciaService } from "../services/boleta-previdencia.service";
import { CadastroBoletaPrevidenciaComponent } from "../cadastro-boleta-previdencia/cadastro-boleta-previdencia.component";
import { UploadPrevComponent } from "../upload-prev/upload-prev.component";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PageEvent } from "@angular/material/paginator";

@Component({
    selector: "app-lista-previdencia",
    templateUrl: "./lista-previdencia.component.html",
    styleUrls: ["./lista-previdencia.component.scss"]
})

export class ListaPrevidenciaComponent extends BaseComponent{

    user:any;
    public search = new FormControl();
    SelectionType = SelectionType;

    selected:any[] = [];
    data:any = {};
    titulo!:string;

    model: any = {
        status_id: "",
        boletas:[]
    };
    
    

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(ListaPrevidenciaComponent, { static: false }) table!: ListaPrevidenciaComponent;
    
    constructor(public service: BoletaPrevidenciaService, 
                public dialog: MatDialog,
                override snackBar: MatSnackBar,
                private route: Router,
                private _authService: AuthService) {
        super(dialog, snackBar);        

        const strUser = this._authService.getUser();
this.user = JSON.parse(strUser? strUser : "{}");
        this.search.setValue("");
        this.getAll();

    }
    /**
     * Evento de ordenação da lista de produtos
     * @param event
     */
    onSort(event:any){

        this.params.sortColumn = event.column.prop;
        
        if(event.column.name == "Responsavel Operação"){
            this.params.sortColumn = "operador_id";
        }else if(event.column.name == "Escritório"){
            this.params.sortColumn = "escritorio_id";
        }else if(event.column.name == "Conta Cliente"){
            this.params.sortColumn = "numero_xp";
        }else if(event.column.name == "Cliente"){
            this.params.sortColumn = "nome_cliente";
        }else if(event.column.name == "Status"){
            this.params.sortColumn = "status_id";
        }        

        this.params.sortOrder = event.newValue;
        this.getAll();
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event:PageEvent){        

        this.params.page = (event.pageIndex+1);
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    getSaldo(row:any){
        return parseFloat(row.valor) - parseFloat(row.vlr_executado);
    }

    /**
     * Consulta lista de Boletas
     */
    getAll() {
        if(this.search.value != null){
            this.params.search = this.search.value;
        }

        this.loadingIndicator = true;
        this.service.getAll(this.params).subscribe(
            data => {
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];
            },
            error => {                
                this.loadingIndicator = false;
                
                if(error.status == 401){        
                    this._authService.logout();
                    this.route.navigate(["/auth/login"]);
                }
            },
            () => {
                this.loadingIndicator = false;
            }
        );
    }

    /**
     * Exclui registro de boleta
     * @param id
     */
    delete(id: number) {

        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: {
                title: "Excluir boleta",
                text: "Deseja realmente excluir este item?",
                callback: function () {
                    lista.dialog.closeAll();

                    lista.loadingIndicator = true;
                    lista.service.delete(id).subscribe(
                        data => {
                            lista.loadingIndicator = false;
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        error => {
                            lista.loadingIndicator = false;                            
                            lista.showError(error.error.message);

                        },
                        () => {                            
                            lista.loadingIndicator = false;
                        }
                    );
                }
            }
        });
    }

    openCadastro(){        
        const dialogRef = this.dialog.open(CadastroBoletaPrevidenciaComponent, {
            width: "500px",
            height: "600px",
            data: {
                acao_comercial_id: null,
                cliente_id: null,
                id: null
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {            
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Boleta Previdência cadastrada com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar cadastrar um nova boleta renda fixa.");
            }
        });        
    }

    openAlterar(id:number){
        const dialogRef = this.dialog.open(CadastroBoletaPrevidenciaComponent, {
            width: "500px",
            height: "600px",
            data: {
                acao_comercial_id: null,
                cliente_id: null,
                id: id
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(result);
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Boleta Previdência atualizada com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar cadastrar um nova boleta COE.");
            }
        });     
    }

    /**
     * Modal de Filtro
     */
    openFiltro(): void {
        const dialogRef = this.dialog.open(FiltrarBoletaComponent, {
            width: "700px",
            maxHeight: "99vh",
            data: { 
                titulo: "Filtrar Boleta",
                status_boleta: true,
                status_ordem: false,
                tipo: "PE"
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != "cancel" && result != undefined) {
                
                this.params.data_operacao_inicio    = result.data_operacao_inicio;
                this.params.data_operacao_fim       = result.data_operacao_fim;
                
                if (result.cliente != undefined && result.cliente != null){
                    this.params.cliente_id = result.cliente.id;
                }

                if (result.assessor_id != undefined && result.assessor_id != null) {
                    this.params.assessor_id = result.assessor_id;
                }

                if (result.escritorio_id != undefined && result.escritorio_id != null) {
                    this.params.escritorio_id = result.escritorio_id;
                }

                if (result.status_id != undefined && result.status_id != null) {
                    this.params.status_id = result.status_id;
                }

                if (result.acao_comercial_id != undefined && result.acao_comercial_id != null) {
                    this.params.acao_comercial_id = result.acao_comercial_id;
                }

                this.paginator.firstPage();
                this.getAll();
            }
        });
    }

    onSelect(selected:any) {        
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
    }
    /**
     * Consulta lista
     */
    getAllExport() {

        this.openLoading();
        this.service.getAllExport(this.params).subscribe(
            data => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank");

            },
            error => {                
                this.closeLoading();
            },
            () => {                
                this.closeLoading();
            }
        );
    }

    getEscritorioCliente(cliente:any){
        if(cliente.escritorio !=undefined && cliente.escritorio != ""){
            return cliente.escritorio.nome_fantasia;
        }

        return "";
    }

    getAssessorCliente(cliente:any){
        if(cliente.assessor !=undefined && cliente.assessor != ""){
            return cliente.assessor.name;
        }

        return "";
    }

    openUpload() : void {
        const dialogRef = this.dialog.open(UploadPrevComponent, {
            width: "400px",          
        });

        dialogRef.afterClosed().subscribe((result: any) => {            
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Previdencias atualizada(s) com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar atualizar o(s) registro(s)");
            }
        });
    }
}
